import { createSelector } from '@reduxjs/toolkit';
import { UPLOAD_LIMIT } from '../../../firebase/storage';

export const getAuthenticated = (state) => state.user.authenticated;
const getTotalSize = (state) => state.user.totalSize;

// Role from the Firebase Auth custom claim (mirrored into Redux by buildReduxUser). Absent = student.
export const getUserRole = (state) => state.user.role || 'student';
export const getIsStaff = (state) =>
  state.user.role === 'instructor' || state.user.role === 'admin';
export const getIsAdmin = (state) => state.user.role === 'admin';

// Denormalized current classroom (set on create/join). Name is shown as the top-bar tag; students
// can't read classrooms/*, so the name is stored on the user doc rather than resolved from the id.
export const getCurrentClassroomName = (state) =>
  state.user.currentClassroomName || '';
export const getCurrentClassroomId = (state) =>
  state.user.currentClassroomId || '';
const getAssetsTotalSize = (state) => state.assets.totalSize;
export const getSketchOwner = (state) => state.project.owner;
const getUserId = (state) => state.user.id;
const limit = UPLOAD_LIMIT;

export const getCanUploadMedia = createSelector(
  getAuthenticated,
  getTotalSize,
  (authenticated, totalSize) => {
    const currentSize = totalSize || 0;
    if (!authenticated) return false;
    // eventually do the same thing for verified when
    // email verification actually works
    if (currentSize >= limit) return false;
    return true;
  }
);

export const getreachedTotalSizeLimit = createSelector(
  getTotalSize,
  getAssetsTotalSize,
  (totalSize, assetsTotalSize) => {
    const currentSize = totalSize || assetsTotalSize || 0;
    if (currentSize >= limit) return true;
    // if (totalSize > 1000) return true;
    return false;
  }
);

export const getIsUserOwner = createSelector(
  getSketchOwner,
  getUserId,
  (sketchOwner, userId) => {
    if (!sketchOwner) return false;
    return sketchOwner.id === userId;
  }
);

const getShareCapability = (state) => state.ide.shareCapability;

// True when the open sketch is a published AR example (set on load from the `examples` collection).
// Absent on legacy/normal projects → falsy. Narrows who may edit (admins only, below).
export const getProjectIsExample = (state) => state.project.isExample === true;

// Editable when: it's a new/unowned sketch, or you opened it via an edit-capability share link,
// otherwise owner/staff — EXCEPT a published example, which only admins may edit (the client mirror
// of the firestore.rules `exists(examples/{id}) ? isAdmin()` branch; staff edit is withdrawn so an
// instructor can't alter a curated example). Gates the file-tree add/upload/delete/rename UI
// (Sidebar, FileNode, ProjectName).
export const selectCanEditSketch = createSelector(
  getSketchOwner,
  getIsUserOwner,
  getShareCapability,
  getIsStaff,
  getIsAdmin,
  getProjectIsExample,
  (sketchOwner, isOwner, shareCapability, isStaff, isAdmin, isExample) => {
    if (!sketchOwner) return true;
    if (shareCapability === 'edit') return true;
    if (isExample) return isAdmin;
    return isOwner || isStaff;
  }
);
